import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { fetchBuyerAnalyticsSummary } from "../../../services/automapBuyerAnalyticsApi";
import {
  AdminAnalyticsNav,
  AnalyticsBreakdownTable,
  AnalyticsRangeSelect,
  AnalyticsSummaryGrid,
} from "./AdminAnalyticsShared";

export default function AdminBuyerAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchBuyerAnalyticsSummary(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const summary = payload?.summary;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Analytics de compradores"
        description="Sesiones, búsquedas, engagement y conversión a leads."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="buyers" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error && summary ? (
          <>
            <AnalyticsSummaryGrid
              items={[
                { label: "Sesiones", value: summary.sessions },
                { label: "Visitantes únicos", value: summary.uniqueVisitors },
                { label: "Page views", value: summary.pageViews },
                { label: "Búsquedas", value: summary.searches },
                { label: "Detalle vehículo", value: summary.vehicleDetailViews },
                { label: "Perfil concesionario", value: summary.dealerProfileViews },
                { label: "Clics WhatsApp", value: summary.whatsappClicks },
                { label: "Leads creados", value: summary.leadsCreated },
                {
                  label: "Conversión lead",
                  value: summary.leadConversionRate != null ? `${summary.leadConversionRate}%` : "—",
                },
                { label: "Quiz iniciados", value: summary.quizStarts },
                { label: "Quiz completados", value: summary.quizCompletions },
                { label: "Checklist abiertos", value: summary.checklistOpens },
                { label: "Guardados", value: summary.savedVehicles },
                { label: "Comparaciones", value: summary.compareAdds },
              ]}
            />
            <div className="admin-analytics-grid">
              <AnalyticsBreakdownTable title="Top landing pages" rows={payload.topLandingPages} keyLabel="Página" />
              <AnalyticsBreakdownTable title="Top vehículos vistos" rows={payload.topVehiclePages} keyLabel="Listing" />
              <AnalyticsBreakdownTable title="Top concesionarios" rows={payload.topDealers} keyLabel="Dealer" />
              <AnalyticsBreakdownTable title="Top campañas" rows={payload.topCampaigns} keyLabel="Campaña" />
              <AnalyticsBreakdownTable title="Top SEO pages" rows={payload.topSeoPages} keyLabel="SEO slug" />
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
